import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const SaveCompanySetUpDetail = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_COMPANY_SETUP_DETAILS, payload, token)
  return res;
};

export const getCompanySize = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_COMPANY_SIZE, token)
  return res;
};

export const GetLocationforClient = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_LOCATION_CLIENT, token)
  return res;
};

export const GetIndustry = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INDUSTRY_DATA_FOR_COMPANY_SETUP, token)
  return res;
};
